const CURRENCY_LIST = [
    {
        shortform: 'AUD',
        shortSymbol: '',
        longform: 'Australian Dollar',
    },
    {
        shortform: 'CNY',
        shortSymbol: '¥',
        longform: 'Chinese Renminbi Yuan',
    },
    {
        shortform: 'EUR',
        shortSymbol: '€',
        longform: 'Euro',
    },
    {
        shortform: 'GBP',
        shortSymbol: '£',
        longform: 'British Pound',
    },
    {
        shortform: 'HKD',
        shortSymbol: 'HK$',
        longform: 'Hong Kong Dollar',
    },
    {
        shortform: 'JPY',
        shortSymbol: '¥',
        longform: 'Japanese Yen',
    },
    {
        shortform: 'MYR',
        shortSymbol: 'RM',
        longform: 'Malaysia Ringgit',
    },
    {
        shortform: 'NZD',
        shortSymbol: '₹',
        longform: 'New Zealand Dollar',
    },
    {
        shortform: 'PHP',
        shortSymbol: '₱',
        longform: 'Philippines Peso',
    },
    {
        shortform: 'SGD',
        shortSymbol: 'S$',
        longform: 'Singapore Dollar',
    },
    {
        shortform: 'THB',
        shortSymbol: '฿',
        longform: 'Thailand Baht',
    },
    {
        shortform: 'USD',
        shortSymbol: '$',
        longform: 'US Dollar',
    },
    {
        shortform: 'BDT',
        shortSymbol: '৳',
        longform: 'Bangladesh Taka',
    },
    {
        shortform: 'BND',
        shortSymbol: '',
        longform: 'Brunei Dollar',
    },
    {
        shortform: 'INR',
        shortSymbol: '₹',
        longform: 'Indian Rupee',
    },
    {
        shortform: 'IDR',
        shortSymbol: 'Rp',
        longform: 'Indonesia Rupiah',
    },
    {
        shortform: 'KRW',
        shortSymbol: '₩',
        longform: 'South Korean Won',
    },
    {
        shortform: 'MOP',
        shortSymbol: '',
        longform: 'Macau Pataca',
    },
    {
        shortform: 'TWD',
        shortSymbol: 'NT$',
        longform: 'Taiwanese NT Dollar',
    },
    {
        shortform: 'VND',
        shortSymbol: '₫',
        longform: 'Vietnamese Dong',
    },
];

const LOCALE_LIST = [
    {
        shortform: 'En',
        longform: 'English',
        default: 'en-gb',
    },
    {
        shortform: 'TH',
        longform: 'ภาษาไทย',
        default: 'th-th',
    },
    {
        shortform: 'ID',
        longform: 'Bahasa Indonesia',
        default: 'id-id',
    },
    {
        shortform: 'ZH',
        longform: '简体中文',
        default: 'zh-cn',
    },
    {
        shortform: 'ZH',
        longform: '繁體中文',
        default: 'zh-tw',
    },
    {
        shortform: 'ZH',
        longform: '繁體中文 (香港)',
        default: 'zh-hk',
    },
    {
        shortform: 'JA',
        longform: '日本語',
        default: 'ja-jp',
    },
    {
        shortform: 'KO',
        longform: '한국어',
        default: 'ko-kr',
    },
    {
        shortform: 'MS',
        longform: 'Bahasa Malaysia',
        default: 'ms-my',
    },
    {
        shortform: 'VI',
        longform: 'Tiếng Việt',
        default: 'vi-vn',
    },
];

const NAVIGATIONS = [
    {
        id: 'myaccount',
        icon: 'account_box',
        label: 'My account',
        redirectUrl: 'https://www.airasia.com/member/myaccount?culture=en-GB',
        newTab: 'TRUE',
    },
    {
        id: 'mybookings',
        icon: 'featured_play_list',
        label: 'My bookings',
        redirectUrl: 'https://www.airasia.com/member/mybookings?culture=en-GB',
        newTab: 'TRUE',
    },
    {
        id: 'mysubscription',
        icon: 'library_books',
        label: 'My subscription',
        redirectUrl: 'https://www.airasia.com/member/mysubscription?culture=en-GB',
        newTab: 'TRUE',
    },
    {
        id: 'mybigpaycheckout',
        icon: 'credit_card',
        label: 'My BigPay Checkout',
        redirectUrl: 'https://www.airasia.com/member/myaccount#bigpaycheckout',
        newTab: 'TRUE',
    },
    {
        id: 'mycases',
        icon: 'assignment_turned_in',
        label: 'My cases',
        redirectUrl: 'https://www.airasia.com/member/mycases?culture=en-GB',
        newTab: 'TRUE',
    },
    {
        id: 'mybigpoints',
        icon: 'money',
        label: 'My BIG Points',
        redirectUrl: 'https://www.airasiabig.com/my/en/profile',
        newTab: 'TRUE',
    },
    {
        id: 'mycreditaccount',
        icon: 'attach_money',
        label: 'My credit account',
        redirectUrl: 'https://booking2.airasia.com/CreditStatusLogin.aspx?culture=en-GB',
        newTab: 'TRUE',
    },
];

const MEMBER_DATA = [
    {
        id: 'bigMemberId',
        icon: '',
        label: 'BIG Member ID',
        redirectUrl: '',
        newTab: 'FALSE',
    },
    {
        id: 'bigMemberPoints',
        icon: '',
        label: 'BIG Points',
        redirectUrl: '',
        newTab: 'FALSE',
    },
    {
        id: 'status',
        icon: '',
        label: 'Status',
        redirectUrl: '',
        newTab: 'FALSE',
    },
];

const LOGIN_MENU = [
    {
        memberData: MEMBER_DATA,
    },
    {
        navigations: NAVIGATIONS,
    },
    {
        logoutButton: [
            {
                id: 'logout',
                icon: '',
                label: 'Log out',
                redirectionUrl: '',
                newTab: 'FALSE',
            },
        ],
    },
];

const TRANSLATIONS = [
    {
        data: [
            {
                settings: 'Settings',
                popularCurrency: 'Suggested currencies',
                popularLocale: 'Popular languages',
                currency: 'Choose a currency',
                locale: 'Choose a language',
                otherCurrency: 'Other supported currency',
                otherLocale: 'Other supported languages',
                mobileLocaleLabel: 'Language',
                mobileCurrencyLabel: 'Currency',
            },
        ],
    },
];

export const data = {
    components: [
        {
            data: [
                {
                    type: 'logo',
                    id: 'aalogo',
                    iconUrl: 'https://static.airasia.com/design/logos/airasiacom_logo.svg',
                    iconName: '',
                    label: '',
                    redirectUrl: 'https://www.airasia.com/en/gb',
                    direction: 'left',
                    newTab: 'TRUE',
                    showInMobilePane: 'FALSE',
                },
                {
                    type: 'navigation',
                    id: 'mybookings',
                    iconUrl: '',
                    iconName: 'CollectionsBookmarkIcon',
                    label: 'My Bookings',
                    redirectUrl: 'https://www.airasia.com/member/search?culture=en-GB',
                    direction: 'right',
                    newTab: 'TRUE',
                    showInMobilePane: 'TRUE',
                },
                {
                    type: 'navigation',
                    id: 'checkin',
                    iconUrl: '',
                    iconName: 'PlaylistAddCheckIcon',
                    label: 'Check-in',
                    redirectUrl: 'https://www.airasia.com/check-in/en/GB',
                    direction: 'right',
                    newTab: 'TRUE',
                    showInMobilePane: 'TRUE',
                },
                {
                    type: 'navigation',
                    id: 'flightstatus',
                    iconUrl: '',
                    iconName: 'FlightTakeoffIcon',
                    label: 'Flight Status',
                    redirectUrl: 'https://www.airasia.com/flightstatus/en/GB',
                    direction: 'right',
                    newTab: 'TRUE',
                    showInMobilePane: 'TRUE',
                },
                {
                    type: 'navigation',
                    id: 'support',
                    iconUrl: '',
                    iconName: 'ForumIcon',
                    label: 'Support',
                    redirectUrl: 'https://support.airasia.com/s/?language=en_GB',
                    direction: 'right',
                    newTab: 'TRUE',
                    showInMobilePane: 'TRUE',
                },
                {
                    type: 'locale-currency',
                    id: 'localecurrency',
                    iconUrl: '',
                    iconName: 'LanguageIcon',
                    label: '',
                    redirectUrl: '',
                    direction: 'right',
                    newTab: '',
                    showInMobilePane: 'TRUE',
                },
                {
                    type: 'login',
                    id: 'login',
                    iconUrl: '',
                    iconName: 'AccountCircle',
                    label: 'Login/Signup',
                    redirectUrl: '',
                    direction: 'right',
                    newTab: '',
                    showInMobilePane: 'FALSE',
                },
            ],
        },
    ],
    defaultLocale: [
        {
            data: [
                {
                    shortform: 'En',
                    longform: 'English',
                    default: 'en-gb',
                    icon: 'LanguageIcon',
                },
            ],
        },
    ],
    defaultCurrency: [
        {
            data: [
                {
                    shortform: 'USD',
                    shortSymbol: '$',
                    longform: 'US Dollar',
                    icon: 'MonetizationOnIcon',
                },
            ],
        },
    ],
    recommendedCurrencyList: [
        {
            data: '',
        },
    ],
    currencyList: [
        {
            data: CURRENCY_LIST,
        },
    ],
    recommendedLocaleList: [
        {
            data: '',
        },
    ],
    localeList: [
        {
            data: LOCALE_LIST,
        },
    ],
    loginTooltip: [
        {
            data: [
                {
                    title: 'Log in now for BIG Member discounts',
                    description: 'Log into get BIG Member discounts and also redeem your unlimited pass',
                    signupButtonText: '',
                    loginButtonText: 'Log in/Sign up',
                },
            ],
        },
    ],
    loginMenu: LOGIN_MENU,
    translations: TRANSLATIONS,
};